
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetSyntheticSelectedIec as ObiAisTargetSyntheticSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-synthetic-selected-iec.js';
 
 
 

 
 export const ObiAisTargetSyntheticSelectedIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-synthetic-selected-iec',
   elementClass: ObiAisTargetSyntheticSelectedIecElement,
   events: {
     
   }
  });
 
 